// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wb5W6iE7ZeMpq1ymAPus .H1XiHZiGjgtzMrDPqdZf{height:44px;font-size:14px;font-weight:500}.Wb5W6iE7ZeMpq1ymAPus .H1XiHZiGjgtzMrDPqdZf.rq3Q1vCRQ7M6fSHZAeNt{margin-top:40px}.Wb5W6iE7ZeMpq1ymAPus .y3YFB3wqk09pjEVVJ28P{margin-bottom:24px}.Wb5W6iE7ZeMpq1ymAPus .qqt0ABDl86oE3f7yvrU2{flex-direction:column;gap:8px;display:flex}.Wb5W6iE7ZeMpq1ymAPus .IdTL4nKlIhQ5r8iaJAWA{color:var(--content-primary-tertiary);margin:32px 0;font-size:14px}.Wb5W6iE7ZeMpq1ymAPus .EaJ_BNhXco0tVkKadtPV{padding:12px;font-size:14px;font-weight:400;line-height:20px}.Wb5W6iE7ZeMpq1ymAPus .EaJ_BNhXco0tVkKadtPV.y3YFB3wqk09pjEVVJ28P{margin-bottom:4px}.Wb5W6iE7ZeMpq1ymAPus .FR0jphpXmoMtH74Ofc8W{margin-top:20px;margin-bottom:4px}.Wb5W6iE7ZeMpq1ymAPus .MtX61szTqnY3s2257NMM{justify-content:center;align-items:center;margin-top:12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Wb5W6iE7ZeMpq1ymAPus`,
	"button": `H1XiHZiGjgtzMrDPqdZf`,
	"signIn": `rq3Q1vCRQ7M6fSHZAeNt`,
	"error": `y3YFB3wqk09pjEVVJ28P`,
	"alertWrap": `qqt0ABDl86oE3f7yvrU2`,
	"divider": `IdTL4nKlIhQ5r8iaJAWA`,
	"textField": `EaJ_BNhXco0tVkKadtPV`,
	"inputLabel": `FR0jphpXmoMtH74Ofc8W`,
	"bottom": `MtX61szTqnY3s2257NMM`
};
export default ___CSS_LOADER_EXPORT___;
